'use strict';

goog.provide("Ntry.Animate");

goog.require("Ntry.STATIC");

Ntry.Animate = function(animate) {
    this.animateType = animate.animateType;

    this.currentFrame = 0;

    this.animateValue = animate.animateValue;

    this.duration = animate.duration ? animate.duration : 1;
};

Ntry.Animate.prototype.type =
    Ntry.STATIC.ANIMATE;
